import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Alert} from 'react-bootstrap';
import moment from 'moment';
import * as constants from '../../const';

class Timer extends Component {
    constructor(props) {
        super(props);
    }

    secondsToTime(secs){
        let formatted = moment.utc(secs*1000).format('mm:ss');
        return formatted;
    }
    
    render() { 
        const isMenumappingConf = this.props.authDetails.activeMenus && Array.isArray(this.props.authDetails.activeMenus) && this.props.authDetails.activeMenus.length > 0;
        var isImpLogin = this.props.authDetails.impersonateUserId > 0
        return(
            <Alert className={!isImpLogin && this.props.authDetails.role == constants.roles.EMPLOYEE_ROLE && isMenumappingConf ? 'timerpopup pull-right show' : 'hidden'}>
                {
                    this.props.authDetails.isOnDutyLoggedin ? 
                        this.props.showTimer ? `You will be in view mode in ${this.secondsToTime(this.props.timerSecs)} seconds.` : 
                            "You are on duty and allowed to edit and certify records"
                        :
                        'Because you are off duty you will be restricted to view mode'
                        //`You are on view mode${this.props.authDetails.editModeOnTime ? ' and will be able to edit on ' + this.props.authDetails.editModeOnTime : '.'}`
                }
            </Alert>
        );
    }
}

function mapStateToProps(state) {
    return {
        showTimer : state.popupmessage.showTimer,
        timerSecs : state.popupmessage.timerSecs,
        authDetails:state.authState
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {

        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Timer);
